import React, { useEffect, useState } from 'react';
import {
  getFormByCode,
  getFormAuths,
} from '../../api/aprvForms';

export default function AprvFormsView({ form, onEdit, token, onDelete }) {
  const [detail, setDetail] = useState(form || null);
  const [auths, setAuths] = useState([]);
  const formCode = form?.form_code;

  // 상세 정보와 권한 로딩
  useEffect(() => {
    if (!formCode) return;

    getFormByCode(formCode)
      .then(res => setDetail(res.data.form || form))
      .catch(() => setDetail(form));

    getFormAuths(formCode, token)
      .then(res => setAuths(Array.isArray(res) ? res : []))
      .catch(() => setAuths([]));
  }, [formCode, form, token]);

  if (!detail) return <div className="text-muted">데이터를 불러오는 중입니다...</div>;

  return (
    <div className="d-flex flex-column gap-3">
      {/* 결재양식 정보 */}
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <span>📄 결재양식 조회</span>
          <div className="d-flex gap-2">
            <button className="btn btn-warning btn-sm" onClick={onEdit}>✏️ 수정</button>
            <button className="btn btn-danger btn-sm" onClick={() => onDelete(detail.form_code)}>
              🗑️ 삭제
            </button>
          </div>
        </div>
        <div className="card-body">
          <p><strong>코드:</strong> {detail.form_code}</p>
          <p><strong>이름:</strong> {detail.form_name}</p>
          <p><strong>유형:</strong> {detail.form_type}</p>
          <p><strong>사용여부:</strong> {detail.use_yn}</p>
          {detail.description && <p><strong>설명:</strong> {detail.description}</p>}
          {detail.form_type === 'form' && detail.sub_form_code && (
            <p><strong>하위 양식 코드:</strong> {detail.sub_form_code}</p>
          )}
        </div>
      </div>

      {/* 권한 관리 (조회 전용) */}
      <div className="card">
        <div className="card-header">🔑 권한 관리</div>
        <div className="card-body">
          {Array.isArray(auths) && auths.length > 0 ? (
            <ul className="list-group mb-3">
              {auths.map(a => (
                <li
                  key={`${a.form_code}-${a.target_type}-${a.target_id}`}
                  className="list-group-item"
                >
                  <strong>{a.target_type === 'user' ? '사용자' : '부서'}:</strong> {a.target_name || a.target_id}
                </li>
              ))}
            </ul>
          ) : (
            <div className="text-muted mb-2">등록된 권한이 없습니다</div>
          )}
        </div>
      </div>
    </div>
  );
}